import { getSharingTipInfo } from './getSharingTipInfo';
import { SharingData } from '../schema/SharingData';
import { getSharingTipIdsList, SharingTipId } from '../types/sharingTipId';
import { SharingTipInfo } from '../types/SharingTipInfo';
import { SharingTipRecipientInfo } from '../types/SharingTipRecipientInfo';

export function getSharingIssuesForSharingData(
    sharingData: SharingData,
    recipientInfo: SharingTipRecipientInfo[]
): SharingTipInfo[] {
    const sharingTipIds: SharingTipId[] = getSharingTipIdsList();

    const sharingTipInfo: SharingTipInfo[] = sharingTipIds
        .filter(id => sharingData.sharingTipsIgnored.indexOf(id) === -1)
        .map(sharingTipId => {
            return getSharingTipInfo([sharingData], sharingTipId, recipientInfo);
        });

    return sharingTipInfo.filter(x => x !== null);
}
